/**
 * Helper para converter links comuns de vídeo (YouTube, Vimeo, Google Drive, Loom)
 * em URLs de embed válidas para iframes.
 */
export const getEmbedUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();

  // YouTube
  // Formatos: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/shorts/ID, youtube.com/embed/ID
  const ytMatch = trimmed.match(/(?:youtube\.com\/(?:watch\?.*v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (ytMatch && ytMatch[1]) {
    return `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1&rel=0`;
  }

  // Vimeo
  // Formatos: vimeo.com/123456789 ou player.vimeo.com/video/123456789
  const vimeoMatch = trimmed.match(/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)([0-9]+)/);
  if (vimeoMatch && vimeoMatch[1]) {
    return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
  }

  // Google Drive
  // Formatos: drive.google.com/file/d/ID/view -> /preview
  if (trimmed.includes('drive.google.com') && trimmed.includes('/view')) {
    return trimmed.replace(/\/view.*$/, '/preview');
  }

  // Loom
  // Formatos: loom.com/share/ID -> loom.com/embed/ID
  if (trimmed.includes('loom.com/share/')) {
    return trimmed.replace('loom.com/share/', 'loom.com/embed/');
  }

  return trimmed;
};

export default getEmbedUrl;
